<div mat-dialog-title class="d-flex align-items-center">
  <div class="d-flex align-items-center w-100">
    <img alt="g-modal-image" *ngIf="true" src="./assets/icons/detalle_modal.svg" class="dhl-dialog-img" />
    <h2 color="red" class="dhl-dialog-title">{{ dialogData.title ? dialogData.title : 'Confirmar' }}</h2>
  </div>
  <div class="flex-shrink-1">
    <div class="position-absolute top-0 end-0 p-2">
      <button mat-icon-button [mat-dialog-close]="false" color="accent">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
</div>
<div mat-dialog-content>
  <div class="row">
    <div class="col">
      <p class="fs-7 dhl-gray" weight="bolder">Motivo de pago</p>
      <h5>
        <strong> - {{ dialogData.Reason }}</strong>
      </h5>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col">
      <p class="fs-7 dhl-gray" weight="bolder">Folio de orden de compra ODC</p>
      <h4 color="black">
        <strong> - {{ dialogData.OrderId }}</strong>
      </h4>
    </div>
  </div>
  <div class="row mb-3 mt-3">
    <div class="col">
      <div class="table-container">
        <mat-table [dataSource]="dataSource" class="scrollable-table">
          <!-- Position Column -->
          <ng-container matColumnDef="position">
            <mat-header-cell *matHeaderCellDef>Fecha</mat-header-cell>
            <mat-cell *matCellDef="let element" [matTooltip]="element.paymentDate">{{ element.paymentDate }}</mat-cell>
            <mat-footer-cell *matFooterCellDef></mat-footer-cell>
          </ng-container>

          <!-- Name Column -->
          <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef>Pago</mat-header-cell>
            <mat-cell *matCellDef="let element" [matTooltip]="element.pay">{{ element.pay }}</mat-cell>
            <mat-footer-cell *matFooterCellDef></mat-footer-cell>
          </ng-container>

          <!-- Weight Column -->
          <ng-container matColumnDef="weight">
            <mat-header-cell *matHeaderCellDef>Monto</mat-header-cell>
            <mat-cell *matCellDef="let element" [matTooltip]="element.totalToPay">{{ element.totalToPay | currency }}</mat-cell>
            <mat-footer-cell *matFooterCellDef></mat-footer-cell>
          </ng-container>

          <!-- Weight Column -->
          <ng-container matColumnDef="fix">
            <mat-header-cell *matHeaderCellDef>Monto pagado</mat-header-cell>
            <mat-cell *matCellDef="let element" [matTooltip]="element.amountPaid">{{ element.amountPaid | currency }}</mat-cell>
            <mat-footer-cell *matFooterCellDef></mat-footer-cell>
          </ng-container>

          <!-- Weight Column -->
          <ng-container matColumnDef="fix2">
            <mat-header-cell *matHeaderCellDef>Saldo</mat-header-cell>
            <mat-cell *matCellDef="let element" [matTooltip]="element.balance">{{ element.balance | currency }}</mat-cell>
            <mat-footer-cell *matFooterCellDef></mat-footer-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns" (click)="selection.toggle(row)"> </mat-row>
          <mat-footer-row *matFooterRowDef="displayedColumns; sticky: false"></mat-footer-row>
        </mat-table>
      </div>
    </div>
  </div>
</div>
<div mat-dialog-actions class="d-flex justify-content-end">
  <button
    *ngIf="dialogData.showCancel"
    mat-stroked-button
    color="accent"
    (click)="onCancel()"
    class="dhl-btn-secundary"
    [innerHTML]="dialogData.cancelLabel ? dialogData.cancelLabel : 'Cancelar'"></button>
  <button *ngIf="dialogData.showAccept" mat-flat-button cdkFocusInitial color="accent" (click)="onAccept()" class="dhl-btn-primary">
    {{ dialogData.acceptLabel ? dialogData.acceptLabel : 'Aceptar' }}
  </button>
</div>
